import BlankOrder from '@components/blank/BlankOrder';
import Column from '@components/Column';
import Header from '@components/Header';
import InfinityScrollTrigger from '@components/InfinityScrollTrigger';
import Loading from '@components/Loading';
import TabItem from '@components/tab/TabItem';
import TabList from '@components/tab/TabList';
import { useStepFlow } from '@router/stackflow';
import { AppScreen } from '@stackflow/plugin-basic-ui';
import { ActivityComponentType } from '@stackflow/react';

import OrderLog from './components/OrderLog';
import useOrderLogs from './hooks/useOrderLogs';
import styles from './styels.module.scss';

interface Params {
    duration: 'WEEK'| 'ONE_MONTH' | 'THREE_MONTH' | 'ALL'
}

const OrderLogsActivity: ActivityComponentType<Params> = ({ params }:{params: Params}) => {
  const { duration } = params;
  const { stepReplace } = useStepFlow('OrderLogsActivity');
  const {
    orderLogs, fetchNext, status, isEmpty,
  } = useOrderLogs(duration);
  return (
      <AppScreen>
          <Header title='주문내역' />
          <TabList variant='solid'>
              <TabItem selected={duration === 'WEEK'}
                       onClick={() => stepReplace({ duration: 'WEEK' })} >
                  1주일
              </TabItem>
              <TabItem selected={duration === 'ONE_MONTH'}
                       onClick={() => stepReplace({ duration: 'ONE_MONTH' })} >
                  1개월
              </TabItem>
              <TabItem selected={duration === 'THREE_MONTH'}
                       onClick={() => stepReplace({ duration: 'THREE_MONTH' })} >
                  3개월
              </TabItem>
              <TabItem selected={duration === 'ALL'}
                       onClick={() => stepReplace({ duration: 'ALL' })} >
                  6개월
              </TabItem>
          </TabList>
          <Column as='main'
                  fullWidth
                  spacing={18}
                  align='center'
                  className={styles.contents} >
              {orderLogs.map((order) => (
                  <OrderLog order={order}
                            key={order.orderNo} />
              ))}
              {isEmpty && (
                  <BlankOrder/>
              )}
              {status === 'pending' && (
                  <Loading size='small'/>
              )}
              <InfinityScrollTrigger trigger={fetchNext}/>
          </Column>
      </AppScreen>
  );
};

export default OrderLogsActivity;
